import * as GtmConstants from './constants';

export function upgradeCtaClicked({ tier, discountType, isTrial }) {
  return {
    type: GtmConstants.Actions.UPGRADE_CTA_CLICKED,
    data: {
      tier,
      discountType,
      isTrial,
    },
  };
}

export function signUpClicked({ tier, discountType, isTrial }) {
  return {
    type: GtmConstants.Actions.SIGN_UP_CLICKED,
    data: {
      tier,
      discountType,
      isTrial,
    },
  };
}

export function upgradeDiscountPlanLinkClicked({ tier, discountType, isTrial }) {
  return {
    type: GtmConstants.Actions.UPGRADE_DISCOUNT_PLAN_LINK_CLICKED,
    data: {
      tier,
      discountType,
      isTrial,
    },
  };
}

export function viewPlansClicked() {
  return {
    type: GtmConstants.Actions.VIEW_PLANS_CLICKED,
  };
}

export function appStoreLinkClicked() {
  return {
    type: GtmConstants.Actions.APP_STORE_LINK_CLICKED,
  };
}
